import axios from "axios";

// Use a relative /api path so the frontend calls whatever origin it's served from.
// This works across preview, emergent.host deployment, and custom domains
// without needing per-domain CORS entries or rebuilds.
// For truly cross-origin dev setups, set REACT_APP_BACKEND_URL explicitly.
const FROM_ENV = process.env.REACT_APP_BACKEND_URL;
const BASE =
  FROM_ENV && typeof window !== "undefined" && !FROM_ENV.startsWith(window.location.origin)
    ? "" // ignore env var when it points to a different origin than the current page
    : (FROM_ENV || "");

export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// A 401 on any non-auth call means the 24h session cookie expired or was
// revoked mid-visit. Tell AuthProvider so <Protected> routes send the user
// back to /login instead of leaving a half-loaded page.
export const SESSION_EXPIRED_EVENT = "fh:session-expired";
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.startsWith("/auth/")) {
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  return typeof detail === "object" ? JSON.stringify(detail) : String(detail);
}
